export default __webpack_public_path__ + "static/media/022-meditate.170dc6cf.svg";